export default __webpack_public_path__ + "static/media/figma.ad871afd.svg";